var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "departures__trip" }, [
    _c("h3", { staticClass: "departures__trip-title" }, [
      _vm._v(_vm._s(_vm.title)),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "departures__summary" }, [
      _c(
        "div",
        {
          staticClass:
            "departures__summary-destination departures__summary-destination--left",
        },
        [
          _c("time", { staticClass: "departures__summary-time" }, [
            _vm._v(_vm._s(_vm.legs[0].departureTime.time)),
          ]),
          _vm._v(" "),
          _c("b", { staticClass: "departures__summary-airport" }, [
            _vm._v(_vm._s(_vm.legs[0].departureAirport.code)),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "departures__summary-stops" }, [
        _vm._v(_vm._s(_vm.stopsDescription)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "departures__summary-destination departures__summary-destination--right",
        },
        [
          _c("time", { staticClass: "departures__summary-time" }, [
            _vm._v(_vm._s(_vm.legs[_vm.legs.length - 1].arrivalTime.time)),
          ]),
          _vm._v(" "),
          _c("b", { staticClass: "departures__summary-airport" }, [
            _vm._v(_vm._s(_vm.legs[_vm.legs.length - 1].arrivalAirport.code)),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "departures__flights" },
      [
        _vm._l(_vm.legs, function (leg, index) {
          return [
            _c(
              "div",
              {
                key: `flight${index}`,
                staticClass: "departures__flight",
                class: {
                  departures__flightTs: _vm.brand === _vm.Brand.Travelsphere,
                },
              },
              [
                _c("div", { staticClass: "departures__flight-logo" }, [
                  _c("picture", [
                    _c("img", {
                      attrs: {
                        src: leg.flightCarrier.logo.image,
                        alt: leg.flightCarrier.logo.altText,
                        loading: "lazy",
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "departures__flight-details" }, [
                  _c("p", { staticClass: "departures__flight-carrier" }, [
                    _vm._v(_vm._s(leg.flightCarrier.name)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "departures__flight-departure" }, [
                    _c("time", { staticClass: "departures__flight-date" }, [
                      _vm._v(_vm._s(leg.departureTime.date)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "departures__flight-time-wrapper" },
                      [
                        _c("time", { staticClass: "departures__flight-time" }, [
                          _vm._v(_vm._s(leg.departureTime.time)),
                        ]),
                        _vm._v(" "),
                        _c("b", { staticClass: "departures__flight-airport" }, [
                          _vm._v(_vm._s(leg.departureAirport.name)),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "departures__flight-arrival" }, [
                    _c("time", { staticClass: "departures__flight-time" }, [
                      _vm._v(_vm._s(leg.arrivalTime.time)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "departures__flight-airport" }, [
                      _vm._v(_vm._s(leg.arrivalAirport.name)),
                    ]),
                    _vm._v(" "),
                    _vm.legs[index + 1]
                      ? _c("time", { staticClass: "departures__flight-date" }, [
                          _vm._v(
                            _vm._s(_vm.legs[index + 1].departureTime.date)
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.legs[index + 1]
              ? _c(
                  "div",
                  {
                    key: `layover${index}`,
                    staticClass: "departures__flight-layover",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "departures__flight-layover-inner" },
                      [_vm._v(_vm._s(_vm.layoverTime(index)))]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }